var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3801 21.8228C5.56753 21.8228 0.855469 17.1107 0.855469 11.2981C0.855469 5.4855 5.56753 0.773438 11.3801 0.773438C17.1928 0.773438 21.9048 5.4855 21.9048 11.2981C21.9048 17.1107 17.1928 21.8228 11.3801 21.8228ZM11.3814 19.9091C16.1372 19.9091 19.9925 16.0537 19.9925 11.298C19.9925 6.54219 16.1372 2.68687 11.3814 2.68687C6.62561 2.68687 2.77029 6.54219 2.77029 11.298C2.77029 16.0537 6.62561 19.9091 11.3814 19.9091ZM8.22766 15.8023L11.3783 12.6517L14.5289 15.8023L15.882 14.4492L12.7314 11.2986L15.882 8.14799L14.5289 6.79489L11.3783 9.94549L8.22766 6.79489L6.87455 8.14799L10.0252 11.2986L6.87455 14.4492L8.22766 15.8023Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/reject_icon.380b7a1d0f2af36bdeffb333205116ab.svg";
export { ForwardRef as ReactComponent };